import React from "react";

export const Footer = () => {
  return (
    <>
      <footer className="footer items-center p-3 justify-center mt-auto flex flex-col gap-6">
        <a
          href="https://www.producthunt.com/posts/promptmaker-manage-generate-prompts?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-promptmaker&#0045;manage&#0045;generate&#0045;prompts"
          target="_blank"
        >
          <img
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=380001&theme=light"
            alt="PromptMaker&#0032;&#0045;&#0032;manage&#0032;&#0038;&#0032;generate&#0032;prompts - Freely&#0032;manage&#0032;and&#0032;generate&#0032;infinite&#0032;prompt&#0032;patterns&#0046; | Product Hunt"
            style={{
              width: "250px",
              height: "54px",
            }}
            width="250"
            height="54"
          />
        </a>
        <div className="flex flex-col gap-1 text-sm text-gray-500">
          <p>©PromptMaker 2023</p>
        </div>
      </footer>
    </>
  );
};
